import React, { Component } from 'react';
import styled from 'styled-components';

import createStore from './messageStore';
import Provider from './messageStore/Provider';
import Header, { headerHeight } from './Header';
import Messages from './Messages';

const Wrapper = styled.div`
  padding-top: ${headerHeight}px;
`;

const store = createStore();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Wrapper>
          <Header />
          <Messages />
        </Wrapper>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js